import React from 'react';
import PropTypes from 'prop-types';

const ProjectTemplatesView = ({
  projectTemplateCards,
  handleAddProjectTemplate,
}) => {
  return (
    <div className="project-templates-view">
      <div className="project-templates-list">
        {projectTemplateCards}
      </div>
      <button 
        className='project-templates-add-button' 
        onClick={handleAddProjectTemplate}
      >
        ADD TEMPLATE
      </button>
    </div>
  );
};

ProjectTemplatesView.propTypes = {
  projectTemplateCards: PropTypes.array.isRequired,
  handleAddProjectTemplate: PropTypes.func.isRequired,
};

export default ProjectTemplatesView;



// WEBPACK FOOTER //
// ./src/containers/ProjectTemplatesContainer/ProjectTypesNav/ProjectTypeNavCard/components/ProjectTemplatesView.js